import React, { useEffect, useRef, useState } from "react";
import {
  I2cHeader,
  I2cBrand,
  I2cIcon,
  I2cButton,
  I2cMenubar,
  I2cAvatar,
  I2cIconButton,
  I2cDropdown,
  I2cMenuItem,
  I2cMenu,
  I2cDrawer,
  I2cActivityFeeds,
  I2cActivityFeedItem,
} from "@webcomponents/i2cwebcomponents/dist/react";
import logo from "../../assets/images/i2c_logo.svg";
import { useNavigate, useLocation } from "react-router-dom";
import AuthService from "../../Services/AuthServices";
import { useQuery } from "react-query";
import { OverlayLoader } from "../Loader/Loader";
import UserManagmentService from "../../Services/UsermanagmentService";
import DarkModeBtn from "../DarkModeBtn/DarkModeBtn";
import "./SecureHeader.scss";
import { UserStateContext } from "../../Context/AuthContext";
import useNotifications from "../../hooks/useNotifications";

const SecureHeader = () => {
  const [open, setNotificationOpen] = useState(false);
  const [openSupport, setSupportOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const appContext = UserStateContext();
  const location = useLocation();
  const navigate = useNavigate();

  // Use the new notification hook with long polling
  const {
    unreadCount,
    notifications: notificationList,
    markAsRead,
    markAllAsRead,
    deleteNotification,
    refresh: refreshNotifications,
    loadMore,
    hasMore,
    isLoadingMore,
  } = useNotifications();

  // Refresh notifications when drawer is opened
  useEffect(() => {
    if (open) {
      refreshNotifications();
    }
  }, [open, refreshNotifications]);
  const header = {
    logo: {
      "--brand-logo-img-width": "2.5rem",
      "--brand-logo-img-height": "auto",
    },
    footer: {},
    lighList: {
      "--list-text-color": "var(--i2c-color-gray-500)",
      "--list-item-external-gap": "var(--i2c-spacing-3)",
      "--list-item-inline-gap": "0",
      "--list-item-block-gap": "0",
      "--list-radius": "0",
    },
    alert: {
      "--footer-spacing": "0.813",
    },
    alertImg: {
      "margin-block": "0.938rem",
      width: "100%",
    },
    alertFooter: {
      display: "flex",
      gap: "0.938rem",
    },
    customSidebarMenu: {
      display: "inline-block",
      border: "1px solid var(--i2c-color-gray-200)",
      width: "20rem",
      "padding-inline": "var(--i2c-spacing-4)",
      paddingBlock: "var(--i2c-spacing-8)",
      position: "relative",
    },
    miscSearchIcon: {
      fontSize: "1.25rem",
    },
    avatartBlockGap: {
      paddingBlock: "0",
    },
  };
  const {
    data: user,
    refetch: refetchUserProfile,
    remove,
  } = useQuery("userProfile", () => UserManagmentService.getUserProfile(), {
    refetchOnWindowFocus: false,
    staleTime: 300000,
  });

  const profileData = user?.data?.data?.user;
  const userRole = String(appContext.userRole || profileData?.role_id || "");
  const roleName = String(
    appContext.roleName || profileData?.role_name || profileData?.roleName || "",
  ).toLowerCase();
  const superAdminUser = userRole === "1" || roleName === "super_admin";
  const adminUser = userRole === "2" || roleName === "admin";
  const clientUser = userRole === "5" || roleName === "client";
  const isViewOnly = userRole === "6" || roleName === "viewonly" || roleName === "view_only";
  const stakeholder = userRole === "7" || roleName === "stakeholder";

  const [showSecureItems, setSecureItems] = useState(true);

  useEffect(() => {
    const showSecureItem = location.pathname.includes("concurrent-sessions")
      ? false
      : true;
    setSecureItems(showSecureItem);
    // Reset loading state when location changes (navigation complete)
    setLoading(false);
  }, [location.pathname]);

  const supportNoti = [
    {
      title: " Help and Support",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio dictumst tempus magna elit cras posuere cursus pulvinar id. Facilisis at eu amet ornare enim arcu malesuada rutrum a.",
      placeholder: "",
    },
    {
      title: " Help and Support",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio dictumst tempus magna elit cras posuere cursus pulvinar id. Facilisis at eu amet ornare enim arcu malesuada rutrum a.",
      placeholder: "",
    },
  ];
  useEffect(() => {
    refetchUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("token")]);

  const handleLogout = () => {
    setLoading(true);
    AuthService.logout()
      .then((res) => {
        localStorage.removeItem("token");
        localStorage.removeItem("session");
        localStorage.removeItem("role");
        localStorage.removeItem("userRole");
        localStorage.removeItem("roleDecrypted");
        localStorage.removeItem("userRoleDecrypted");
        navigate("/login");
        remove();
      })
      .catch((e) => {
        localStorage.removeItem("token");
        localStorage.removeItem("session");
        localStorage.removeItem("role");
        localStorage.removeItem("userRole");
        localStorage.removeItem("roleDecrypted");
        localStorage.removeItem("userRoleDecrypted");
        navigate("/login");
        remove();
      })
      .finally(() => setLoading(false));
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  function handleSupportRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const handleItemClick = (notification) => {
    const { form, id, is_read } = notification;

    // Show loader immediately
    setLoading(true);

    // Mark as read if not already read (fire and forget - optimistic update)
    if (!is_read) {
      markAsRead(id).catch(err => {
        console.error('Failed to mark notification as read:', err);
      });
    }

    // Navigate immediately
    if (form?.type && form?.id) {
      setNotificationOpen(false);
      // Small delay to ensure drawer closes smoothly before navigation
      setTimeout(() => {
        if (form.type === 1) {
          navigate(`/debit/edit/${form.id}`);
        } else {
          navigate(`/credit/edit/${form.id}`);
        }
      }, 100);
    } else {
      setLoading(false);
    }
  };

  const handleMarkAllAsRead = async () => {
    try {
      await markAllAsRead();
    } catch (err) {
      console.error('Failed to mark all as read:', err);
    }
  };

  const handleDeleteNotification = async (event, notificationId) => {
    event.stopPropagation();
    try {
      await deleteNotification(notificationId);
    } catch (err) {
      console.error('Failed to delete notification:', err);
    }
  };

  return (
    <>
      {loading && (
        <OverlayLoader
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        />
      )}
      {/* <OverlayLoader /> */}
      <div part={"i2c-header"}>
        <I2cHeader
          id="basicHeader1"
          className="header-container"
          responsive
          toggle-align="start"
          secure
          bend
        >
          <I2cBrand
            className="secureHeaderLogo"
            slot="brand"
            logo={logo}
            target=""
            style={header.logo}
            label=""
          ></I2cBrand>
          {!clientUser  && (
            <div slot="items" className="secureHeaderItems">
              {showSecureItems && (
                <I2cMenubar id="basicHeaderMenuBar1">
                  {!isViewOnly && !stakeholder && (
                    <I2cButton
                      onClick={() => navigate("/sales")}
                      variant={
                        window.location.pathname.includes("sales")
                          ? "secondary color"
                          : "tertiary gray"
                      }
                      className={
                        window.location.pathname.includes("sales")
                          ? "secondary-color"
                          : ""
                      }
                      menu-btn
                      size="medium"
                    >
                      Sales Queue
                    </I2cButton>
                  )}
                  <I2cButton
                    onClick={() => navigate("/impl")}
                    variant={
                      window.location.pathname.includes("impl")
                        ? "secondary color"
                        : "tertiary gray"
                    }
                    className={
                      window.location.pathname.includes("impl")
                        ? "secondary-color"
                        : ""
                    }
                    size="medium"
                    menu-btn
                  >
                    Imp. Queue
                  </I2cButton>
                  {(adminUser || superAdminUser) && (
                    <I2cButton
                      onClick={() => {
                        navigate("/users");
                      }}
                      menu-btn
                      variant={
                        window.location.pathname.includes("users")
                          ? "secondary color"
                          : "tertiary gray"
                      }
                      className={
                        window.location.pathname.includes("users")
                          ? "secondary-color"
                          : ""
                      }
                      size="medium"
                    >
                      User Management
                    </I2cButton>
                  )}
                </I2cMenubar>
              )}
            </div>
          )}
          <div slot="misc" className="secureHeaderMisc">
            <DarkModeBtn />
            {/*{showSecureItems && (*/}
            {/*  <I2cIconButton*/}
            {/*    onClick={() => setSupportOpen(true)}*/}
            {/*    name={"cs-linear-help-circle"}*/}
            {/*    label={"Edit"}*/}
            {/*    style={header.miscSearchIcon}*/}
            {/*  ></I2cIconButton>*/}
            {/*)}*/}
            {showSecureItems && (
              <div className="notification-badge-wrapper">
                <I2cIconButton
                  onClick={() => setNotificationOpen(true)}
                  name={"linear-notification-bing"}
                  label={"Notification"}
                  style={header.miscSearchIcon}
                ></I2cIconButton>
                {unreadCount > 0 && (
                  <span className="notification-badge">
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </span>
                )}
              </div>
            )}
            {showSecureItems && (
              <I2cDropdown
                foot
                distance="16"
                placement="bottom-end"
                // disabled={loading}
                head
                className="header_dropdown"
                width="calc(var(--i2c-spacing-56) + var(--i2c-spacing-6))"
              >
                <I2cAvatar
                  style={header.avatartBlockGap}
                  image={
                    `data:image/jpeg;base64,${profileData?.avatar}` ??
                    "../assets/images/avatar.svg"
                  }
                  label={profileData?.email ?? "-"}
                  slot="trigger"
                  size="large"
                ></I2cAvatar>
                {loading && <OverlayLoader hideSpinner={true} />}
                <div slot="head">
                  <div className="userTitle">{profileData?.name ?? "-"}</div>
                  <div className="userEmail">{profileData?.email ?? "-"}</div>
                </div>
                <I2cMenu
                  className="auth-dropdown-header"
                  style={{ zIndex: "auto" }}
                >
                  <I2cMenuItem
                    disabled={loading}
                    size="large"
                    onClick={() => !loading && navigate("/profile")}
                    value="profile"
                  >
                    <I2cIcon slot="prefix" name="linear-profile-circle"></I2cIcon>
                    View Profile
                  </I2cMenuItem>
                </I2cMenu>
                <div slot="foot">
                  <I2cMenuItem
                    disabled={loading}
                    onClick={() => !loading && handleLogout()}
                  >
                    <I2cIcon
                      slot="prefix"
                      name="linear-logout-1"
                      className="error-icon-header"
                    ></I2cIcon>
                    Logout
                  </I2cMenuItem>
                </div>
              </I2cDropdown>)}
          </div>
        </I2cHeader>
      </div>
      {/* Notification Drawer */}
      <I2cDrawer
        label="Notifications"
        sub-label=""
        open={open}
        onI2cRequestClose={handleRequestClose}
        onI2cAfterHide={() => setNotificationOpen(false)}
        className="drawer-activity-feed"
        style={{ zIndex: 9999 }}
      >
        {notificationList && notificationList.length > 0 ? (
          <> 
            <I2cActivityFeeds
              variant="divider"
              type="notification"
              className="i2c-activity-feeds cursor_notification"
            >
              {notificationList.map((data, index) => (
                <I2cActivityFeedItem
                  key={data.id || index}
                  label={data.assigner?.name || 'Unknown'}
                  time={data.created_at}
                  events={data.message}
                  onClick={() => handleItemClick(data)}
                  style={{
                    backgroundColor: data.is_read ? 'transparent' : 'var(--i2c-color-blue-50)',
                    position: 'relative'
                  }}
                  {...(!data.is_read && { 'new-item': true })}
                >
                  <I2cAvatar
                    style={header.avatartBlockGap}
                    image={
                      data?.assigner?.avatar?.avatar
                        ? `data:image/jpeg;base64,${data.assigner.avatar.avatar}`
                        : "../assets/images/avatar.svg"
                    }
                    label={data?.assigner?.email ?? "-"}
                    slot="feed-avatar"
                    size="large"
                  ></I2cAvatar>
                  {!data.is_read && (
                    <span style={{
                      position: 'absolute',
                      left: '8px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '8px',
                      height: '8px',
                      backgroundColor: '#3B82F6',
                      borderRadius: '50%',
                    }} />
                  )}
                </I2cActivityFeedItem>
              ))}
            </I2cActivityFeeds>
            {hasMore && (
              <div className="load-more-container">
                <I2cButton 
                  variant="secondary gray" 
                  size="medium" 
                  onClick={loadMore}
                  disabled={isLoadingMore}
                >
                  {isLoadingMore ? 'Loading...' : 'Load More'}
                </I2cButton>
              </div>
            )}
            {unreadCount > 0 && (
              <div slot="footer">
                <div className={"drawer-footer"}>
                  <I2cButton variant="link color" size="medium"  onClick={handleMarkAllAsRead}>  Mark all {unreadCount} notification{unreadCount !== 1 ? 's' : ''} as read</I2cButton>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="no-notification-container">
              <div className="notify-container">
                <I2cIcon
                  className="cs-icon-shadowed"
                  variant="shadowed"
                  name="linear-info-circle"
                />
                <div className="no-user-title">No New Notifications</div>
              </div>
            </div>
          </>
        )}
      </I2cDrawer>
      {/* Help & Support Drawer          */}
      <I2cDrawer
        label="Help and Support"
        sub-label=""
        open={openSupport}
        onI2cRequestClose={handleSupportRequestClose}
        onI2cAfterHide={() => setSupportOpen(false)}
        ref={I2cDrawer}
      >
        <I2cActivityFeeds
          variant=""
          type="notification"
          className="i2c-activity-feeds"
        >
          {supportNoti.map((data, index) => (
            <div key={index} className="hs-listing">
              <div className="hs-subtitle">{data.title}</div>
              <p className="hs-text">{data.desc}</p>
              <div className="hs-placeholder">{data.placeholder}</div>
            </div>
          ))}
        </I2cActivityFeeds>
      </I2cDrawer>
    </>
  );
};

export default SecureHeader;
